import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Card from '../../base/Card/Card.js';
import Text from '../../base/Text/Text.js';

import { ICommentaryConfiguration, ICommentaryProps, ICommentaryState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { COMMENTARY_CATEGORY_KEY, COMMENTARY_COMPONENT_KEY } from './Commentary.meta.js';

export class Commentary extends ComponentBase<ICommentaryProps, ICommentaryState, ICommentaryConfiguration> {
	categoryKey = COMMENTARY_CATEGORY_KEY;
	componentKey = COMMENTARY_COMPONENT_KEY;

	constructor(props: ICommentaryProps) {
		super(props);
	}
	render() {
		const { className, cardProps, textProps } = this.props;
		return (
			<Wrapper className={className}>
				<Card {...(cardProps || {})}>
					<Text {...(textProps || { value: '' })} />
				</Card>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Commentary), COMMENTARY_CATEGORY_KEY, COMMENTARY_COMPONENT_KEY);
